var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.920898 9.07812C0.688477 9.31055 0.681641 9.70703 0.920898 9.94629C1.15332 10.1855 1.5498 10.1787 1.78906 9.94629L5.28906 6.43945L8.7959 9.94629C9.02832 10.1787 9.4248 10.1855 9.65723 9.94629C9.90332 9.70703 9.89648 9.31055 9.65723 9.07812L6.15723 5.57129L9.65723 2.07129C9.89648 1.83887 9.90332 1.43555 9.65723 1.20312C9.4248 0.963867 9.02832 0.970703 8.7959 1.20312L5.28906 4.70996L1.78906 1.20312C1.5498 0.970703 1.15332 0.963867 0.920898 1.20312C0.681641 1.43555 0.688477 1.83887 0.920898 2.07129L4.4209 5.57129L0.920898 9.07812Z",
    fill: "#2C71C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f6d8162a96dece92a7536fd1961fcce6.svg";
export { ForwardRef as ReactComponent };